import React, { useMemo, useState, useRef } from 'react'
import { Skeleton } from '../../../components/Skeleton'
import { useSourcesCountQuery } from '../../../requests/sources'
import { useInView } from '../../../hooks/useInView'

type Props = {
  inboxId: string
}

export const InboxSourcesCount: React.FC<Props> = ({ inboxId }) => {
  const [isInView, setIsInView] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  // Memoize the date calculation to prevent rerendering loops
  // Set time to midnight so the cache key persists throughout the day
  const sevenDaysAgo = useMemo(() => {
    const now = new Date()
    const date = new Date(now)
    date.setDate(date.getDate() - 7)
    date.setHours(0, 0, 0, 0) // Set to midnight for consistent caching key
    return date
  }, [])

  const {
    data: sourcesCount = 0,
    isLoading: loading
  } = useSourcesCountQuery(
    inboxId,
    {
      startDate: sevenDaysAgo,
      ignore: false
    },
    {
      enabled: isInView, // Only fetch when component is in view
    }
  )

  useInView(containerRef, {
    rootMargin: '100px',
    triggerOnce: true,
    onIntersect: () => setIsInView(true)
  })

  if (loading) {
    return (
      <div ref={containerRef}>
        <Skeleton width={50} />
      </div>
    )
  }

  return (
    <div ref={containerRef}>
      {sourcesCount} new source{sourcesCount === 1 ? '' : 's'} a week
    </div>
  )
}
